var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,0C14.4,0,0,14.5,0,32.1s14.3,32,32,32s32-14.5,32-32.1S49.6,0,32,0z M32,59.1C17,59.1,4.9,47,4.9,31.9 S17,4.8,32,4.8s27.1,12.1,27.1,27.1S47,59.1,32,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,44c-0.1-0.5-0.3-1.3-0.5-2c-0.1-0.5-0.3-1-0.4-1.5c-0.2-0.8-0.4-1.6-0.6-2.4c-0.9-3.5-2.4-4.8-5.5-4.8 h-4.5v-5.5c0-2-0.6-3.5-1.8-4.6c2.4-0.6,4.2-2.8,4.2-5.3c0-3.1-2.5-5.5-5.6-5.5c-3,0-5.3,2.3-5.6,5.4v0.2c0,1.9,1,3.7,2.7,4.7h-0.1 c-0.7,0.3-3.1,1.4-4.7,2.2c-2.7,1.4-2.9,3.5-2.9,5.3v0.9l-0.4,0.2c-3.4,2.1-5.4,5.6-5.4,9.6c0,6.2,5,11.1,11.2,11.1 c5.4,0,10.1-3.9,11-9.2c0.5,2,1.3,5.1,1.3,5.1c0.5,1.9,1.5,3.1,2.7,3.7c0.5,0.2,1.1,0.3,1.6,0.3c0.6,0,1.3-0.2,2-0.5 c2.2-1.3,2.8-3.5,1.7-6.9L47.4,44z M44.4,48.7c-0.2,0.1-0.7,0.3-1.1,0.1s-0.8-0.8-1.1-1.7c-0.7-2.5-1.6-6-1.6-6.2v-0.1 c-0.3-1.2-1.1-2-2.1-2h-1.3c-0.2-0.8-0.5-1.6-0.9-2.6h4c1.5,0,2,0,2.7,2.5c0.3,1.2,0.7,2.7,1,3.9c0.5,1.9,0.7,2.6,0.8,2.9l0,0 C45.6,48.1,44.8,48.5,44.4,48.7z M26.4,40.1c1.2,0,2.3-0.7,2.7-1.7c0.5-1,0.7-2,0.7-3.2v-1.9c2.7,1,4.7,3.5,5.1,6.5l0.2,0.7v0.4 c0,4.4-3.6,8.1-8.2,8.1s-8.2-3.6-8.2-8.1c0-2.6,1.4-5.1,3.6-6.7v2C22.5,38.7,24.5,40.1,26.4,40.1z M31.1,25.2 c0.3,0,0.5,0.1,0.7,0.2c0.5,0.4,0.7,1.1,0.7,2.2v4.4c-0.9-0.5-1.8-1-2.8-1.2v-0.3c0-0.7-0.5-1.1-1-1.1c-0.7,0-1.1,0.5-1.1,1.1v4.6 c0,1.4-0.4,2.8-1.2,2.8c-0.7,0-1.5-0.6-1.5-1.9l-0.1-6c0-1.5,0.1-2,1.4-2.7l0,0c1.6-0.9,4.1-2,4.4-2.1 C30.7,25.2,30.9,25.2,31.1,25.2z M32.5,20.3c-1.4,0-2.5-1.1-2.5-2.5c0.1-1.5,1.2-2.6,2.5-2.6c1.4,0,2.5,1.1,2.5,2.5 C35,19,33.9,20.3,32.5,20.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType17);
export default __webpack_public_path__ + "static/media/aioa-icon-type-17.784a00e2a2967b2915c92d900e5cfdc0.svg";
export { ForwardRef as ReactComponent };